import React from "react";
import { useMediaQuery, useTheme } from "@mui/material";
import ISO from './images/MicrosoftColab.webp';
import './MicrosoftCert.css';

export default function MicrosoftCert() {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <React.Fragment>
            <div>
                <div style={{ margin: "3rem 0 0 4%" }}>
                    <span className={isSmallScreen ? "only-heading-sm" : "only-heading"}>Microsoft</span>
                    <span className={isSmallScreen ? "gradient-heading-sm" : "gradient-heading"}> Collaboration</span>
                </div>
                <div style={{ width: "100%", margin: "3rem 0 3rem 0" }}>
                    <img class="module-border-wrap" src={ISO} style={{ margin: "auto", display: "block", width: isSmallScreen ? "100%" : "50%" }} />
                    <div style={{ textAlign: "center", marginTop: "1rem", fontWeight: "500" }}>
                        <a href="https://marketplace.microsoft.com/en-us/marketplace/partner-dir/2f6c32be-8a41-4258-8ae2-78eb0e92e44e/overview" style={{ color: "#01A6F0", cursor: "pointer" }}>
                            Click here</a> to Verify & Validate
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}